import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import LazyPicture from "../../../LazyPicture/components/LazyPicture/LazyPicture.js";
const CertificatesItem = ({ link, image, mobileImage, title, text }) => {
  if (!image) {
    console.warn(`Cannot render Certificate: missing image`);
    return null;
  }
  const LinkElement = !!link ? "a" : "div";
  return /* @__PURE__ */ React.createElement("section", { className: classnames("certificates-item", {}) }, /* @__PURE__ */ React.createElement(
    LinkElement,
    {
      className: classnames("certificates-item__container", {
        "certificates-item__container--center": !title && !text
      }),
      href: link?.url || void 0
    },
    image && /* @__PURE__ */ React.createElement("div", { className: "certificates-item__image-container" }, /* @__PURE__ */ React.createElement(LazyPicture, { image, mobileImage })),
    (title || text) && /* @__PURE__ */ React.createElement("div", { className: "certificates-item__content" }, title && /* @__PURE__ */ React.createElement(Heading, { variant: "small", className: "certificates-item__title" }, title), text && /* @__PURE__ */ React.createElement("p", { className: "certificates-item__description" }, text))
  ));
};
export {
  CertificatesItem as default
};
//# sourceMappingURL=CertificatesItem.js.map
